import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AuthLayout from 'features/auth/ui/AuthLayout'
import Button from 'shared/ui/Button'
import { useTranslation } from 'shared/i18n'
import { IP_NOT_ALLOWED_CONTACT } from './ipNotAllowedContact'

interface IpNotAllowedViewProps {
  /** 接続元 IP。取れない（形式が不正を含む）場合は null で、IP の行を出さない。 */
  clientIp: string | null
  /** 問い合わせ先。決まるまで空で、空の間は何も表示しない（既定は設定値）。 */
  contact?: string
}

const TEXT_FONT = { fontFamily: '"Noto Sans JP", sans-serif' } as const

/**
 * IP 制限による拒否画面（ADR-0088 決定 7.1）。
 * ログイン画面での拒否と、ログイン後の画面遷移での拒否の両方で、アプリ全体の代わりに出す。
 * `clientIp` は React のテキストとして描画する（HTML として解釈しない）。
 */
export default function IpNotAllowedView ({ clientIp, contact = IP_NOT_ALLOWED_CONTACT }: IpNotAllowedViewProps): JSX.Element {
  const { t } = useTranslation()

  return (
    <AuthLayout>
      <Box
        data-testid="ip-not-allowed"
        role="alert"
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, textAlign: 'center' }}
      >
        <Typography component="h1" sx={{ ...TEXT_FONT, fontSize: 16, fontWeight: 500 }}>
          {t('auth.ipNotAllowedView.title')}
        </Typography>
        {clientIp != null && (
          <Typography sx={{ ...TEXT_FONT, fontSize: 14 }}>
            {t('auth.ipNotAllowedView.clientIp')}
            <Box component="span" sx={{ fontFamily: 'monospace', fontWeight: 700, ml: 1 }}>
              {clientIp}
            </Box>
          </Typography>
        )}
        {/* 許可された IP へ移った後に抜けられるよう、読み込み直すこと自体が目的の再読み込みを置く（spa-navigation.md の例外）。 */}
        <Button
          // eslint-disable-next-line jizaipad-policy/no-full-page-navigation -- 読み込み直すこと自体が目的
          onClick={() => { window.location.reload() }}
          variant="outlined"
        >
          {t('auth.ipNotAllowedView.reload')}
        </Button>
        {contact !== '' && (
          <Typography sx={{ ...TEXT_FONT, fontSize: 12, color: 'rgba(0, 0, 0, 0.6)' }}>
            {contact}
          </Typography>
        )}
      </Box>
    </AuthLayout>
  )
}
